import { themeVars, toBorder } from '@tundr/theme';
import { globalStyle, style } from '@vanilla-extract/css';

globalStyle('input[type="radio"]', {
  WebkitAppearance: 'none',
  appearance: 'none',
  margin: 0,
  font: 'inherit',
  color: 'currentcolor',
  minWidth: 23,
  height: 23,
  borderRadius: themeVars.radius.circle,
  transform: 'translateY(-1px)',
  display: 'grid',
  placeContent: 'center',
  cursor: 'pointer',
  overflow: 'hidden',
  transition: themeVars.transitions.default,
  border: toBorder(themeVars.colors.neutrals.black100),
  backgroundColor: themeVars.colors.neutrals.white,
  padding: themeVars.space.x2,
});

globalStyle('input[type="radio"]:checked', {
  backgroundColor: themeVars.colors.brand.primary.x100,
  boxShadow: 'inset 0 0 0 3px white',
});

globalStyle('input[type="radio"]::before', {
  position: 'absolute',
  content: '',
  left: 0,
  top: 0,
});

export const radioboxWrapperClass = style({
  display: 'flex',
  alignItems: 'flex-start',
  cursor: 'pointer',
  gap: themeVars.space.x3,
});

export const radioboxElementClass = style({
  marginTop: themeVars.space.x1,
});

export const radioboxLabelClass = style({
  cursor: 'pointer',
  fontSize: themeVars.font.size.textMd,
  position: 'relative',
  top: 2,
});
